import * as React from "react";
import { createIcon } from "@chakra-ui/react";

const Folder = createIcon({
  path: (
    <path
      d="M2.86338 16C0.977739 16 0 15.0467 0 13.2088V2.73967C0 0.936125 0.960279 0 2.59275 0H5.06329C5.97119 0 6.42514 0.163178 7.03623 0.661299L7.54256 1.05636C8.0227 1.44283 8.38935 1.58884 9.0179 1.58884H17.1366C19.0223 1.58884 20 2.54214 20 4.38003V13.2088C20 15.0467 19.031 16 17.3636 16H2.86338ZM1.71104 2.88567V5.02415H18.289V4.52603C18.289 3.68438 17.8437 3.27214 17.0406 3.27214H8.56395C7.65605 3.27214 7.18464 3.10896 6.58228 2.61943L6.07595 2.21578C5.58708 1.82072 5.22916 1.68331 4.60934 1.68331H2.93322C2.14753 1.68331 1.71104 2.09554 1.71104 2.88567ZM2.96814 14.3167H17.0406C17.8437 14.3167 18.289 13.9045 18.289 13.0714V6.50993H1.71104V13.0714C1.71104 13.9045 2.15626 14.3167 2.96814 14.3167Z"
      fill="currentColor"
    />
  ),
  viewBox: "0 0 20 18",
});

export { Folder };
